import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enTranslation from 'common/locales/en/translation.json';
import srTranslation from 'common/locales/sr/translation.json';
import esTranslation from 'common/locales/es/translation.json';
import cnrTranslation from 'common/locales/cnr/translation.json';
import { ELanguage, EStorageKey } from 'common/const';

const resources = {
  [ELanguage.EN]: {
    translation: enTranslation,
  },
  [ELanguage.SR]: {
    translation: srTranslation,
  },
  [ELanguage.ES]: {
    translation: esTranslation,
  },
  [ELanguage.CNR]: {
    translation: cnrTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.values(ELanguage),
    fallbackLng: ELanguage.EN,
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: EStorageKey.Lang,
    },
    resources,
  });

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});
